import getters from '~/store/modules/shared/i18n/getters'
import mutations from '~/store/modules/shared/i18n/mutations'
import state from '~/store/modules/shared/i18n/state'
import { createModule } from '~/factories/store'

export default createModule({
  getters,
  mutations,
  state
})
